import { render, staticRenderFns } from "./import-step3.vue?vue&type=template&id=bd3a0a8a"
import script from "./import-step3.vue?vue&type=script&lang=js"
export * from "./import-step3.vue?vue&type=script&lang=js"
import style0 from "./import-step3.vue?vue&type=style&index=0&id=bd3a0a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports